import React, { useEffect, useState } from "react";
import AppContainer from "../Components/Structure/AppContainer";
import BestAttendantCard from "../Components/dashboard/BestAttendantCard";
import CompanyGraphs from "../Components/Graphs/CompanyGraphs";
import StationGraphs from "../Components/Graphs/StationGraphs";
import StationFuelBalancesChart from "../Components/Graphs/StationFuelBalancesChart";
import ViewStationRecentSalesComponent from "../Components/Sales/ViewStationRecentSalesComponent";
import FuelPricesTable from "../Components/fuelPrices/FuelPricesTable";
import StationsCardsComponent from "../Components/dashboard/StationsCardsComponent";
import CompanyCardsComponent from "../Components/dashboard/CompanyCardsComponent";
import StationDeliveredFuelTable from "../Components/deliveries/MonthStationDeliverySummary";
import StationDeliveredFuelCards from "../Components/deliveries/StationDeliveredFuelCards";
import BestStationCard from "../Components/Sales/BestStationCard";
function Dashboard() {
  const isCompanyUser = localStorage.getItem("FuelFy@is_company_user");
  const activeStationId = localStorage.getItem("FuelFy@station_id");
  const [showWelcome, setShowWelcome] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setShowWelcome(false), 5000);
    return () => clearTimeout(timer);
  }, []);
  // Helper functions for conditional rendering
  const renderCards = () => {
    if (activeStationId) return <StationsCardsComponent />;
    if (isCompanyUser) return <CompanyCardsComponent />;
    return null;
  };
  const renderGraphs = () => {
    if (activeStationId) return <StationGraphs />;
    if (isCompanyUser) return <CompanyGraphs />;
    return null;
  };
  const renderRecentSales = () => {
    if (activeStationId) return <ViewStationRecentSalesComponent />;
    return null;
  };
  const renderRightSection = () => {
    return (
      <>
        {activeStationId && (
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="card-title mb-1">Current Fuel Prices</h6>
              <p className="text-muted mb-0 card-sub-title text-danger">
                All sales calculations will be done using these prices
              </p>
              <FuelPricesTable />
            </div>
          </div>
        )}
        {activeStationId && (
          <div className="card custom-card">
            <div className="card-body" style={{ height: "350px" }}>
              <StationFuelBalancesChart />
            </div>
          </div>
        )}
        {activeStationId && (
          <div className="card custom-card">
            <div className="card-body" style={{ height: "280px" }}>
              <BestAttendantCard />
            </div>
          </div>
        )}
        {!activeStationId && isCompanyUser && (
          <div className="card custom-card">
            <div className="card-body" style={{ height: "280px" }}>
              <BestStationCard />
            </div>
          </div>
        )}
        {activeStationId && (
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="card-title mb-1">
                Totals of Fuel Deliveries this Month
              </h6>
              <p className="text-muted mb-0 card-sub-title text-danger">
                delivery per fuel category Sum
              </p>
              <StationDeliveredFuelTable />
            </div>
          </div>
        )}
        {!activeStationId && isCompanyUser && (
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="card-title mb-1">
                Totals of Fuel Deliveries this Month
              </h6>
              <p className="text-muted mb-0 card-sub-title text-danger">
                delivery per fuel category Sum per station
              </p>
              <StationDeliveredFuelCards />
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <AppContainer title="Dashboard" previousPageTitle="Home" actions={[]}>
      <div className="col-lg-12">
        <div className="row">
          {/* left section */}
          <div className="col-lg-8 col-md-12">
            <div className="row">{renderCards()}</div>
            <div className="row">{renderGraphs()}</div>
            <div className="row">{renderRecentSales()}</div>
          </div>
          {/* right section */}
          <div className="col-lg-4 col-md-12">{renderRightSection()}</div>
        </div>
      </div>
    </AppContainer>
  );
}
export default Dashboard;
